import { render, staticRenderFns } from "./REAIPromptDetail.vue?vue&type=template&id=0e58c2bb"
import script from "./REAIPromptDetail.vue?vue&type=script&lang=js"
export * from "./REAIPromptDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports